module.exports = __webpack_public_path__ + "assets/img/ruleBottomBgimg.9b275128.jpg";